import WeddingInvitationEditPage from "@/views/wedding/WeddingInvitationEditPage.vue";
import WeddingInvitationPage from "@/views/wedding/WeddingInvitationPage.vue";

const weddingRoutes = [
  {
    path: "/wedding",
    name: "WeddingInvitationPage",
    component: WeddingInvitationPage,
  },
  {
    path: "/wedding/edit/:weddingInvitationSeq",
    name: "WeddingInvitationEditPage",
    components: {
      default: WeddingInvitationEditPage
    },
    props: {
      default: true
    }
  }
]

export default weddingRoutes;